export default {
  path: '/vendors',
  name: 'vendors',
  component: () => import(/* webpackChunkName: "list-view-vendors" */ './ListViewVendors'),
  meta: {
    requiresAuth: true
  }
}
